import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import CornTortillaProduct from 'models/CornTortillaProduct'
import CornTortillaPackage from './CornTortillaPackage'
import BrandSpecificProductDesc from 'views/shared/BrandSpecificProductDesc'
import { brandNameOptions } from './constants'

const productOptions = {
  // eslint-disable-next-line react/display-name
  productDesc: () => (
    <BrandSpecificProductDesc
      initialBrandNameOptions={brandNameOptions}
      isSRPURequired={false}
    />
  ),
  packagingInfo: <CornTortillaPackage />,
  productTitle: 'Corn Tortillas (Soft)',
  model: CornTortillaProduct,
  validCategories: ['16'],
  validSubCategories: ['007'],
  brandSpecific: false,
}

const CornTortilla = () => <ProductForm product={productOptions} />

export default CornTortilla

export const getCornTortillaPackage = newProduct => {
  const newCornTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newCornTortillaPackage
}

export const updateCornTortillaPackage = newProduct => {
  const newCornTortillaPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newCornTortillaPackage
}
